(() => {
  'use strict';
  const root = document.querySelector('[data-everyday-wallet]');
  if (!root || root.dataset.ewBfReady) return;
  const banner = root.querySelector('[data-ew-bf]');
  if (!banner) return;
  const end = Date.parse(banner.dataset.end);
  const fallback = root.querySelector('[data-ew-bf-fallback]');
  const badge = root.querySelector('[data-ew-bf-price-badge]');
  const originalBadge = badge?.textContent;
  const clock = banner.querySelector('[data-ew-bf-clock]');
  const off = banner.querySelector('[data-ew-bf-discount]');
  const reference = banner.querySelector('[data-ew-bf-reference]');
  let timer = null;
  let variants = [];
  try { variants = JSON.parse(root.querySelector('[data-wallet-config]')?.textContent || '{}').variants || []; } catch (_) { /* Preserve the native purchase flow if sale data is missing. */ }
  function discount(variant) {
    const price = Number(variant?.price), compare = Number(variant?.compareAt);
    const valid = Number.isSafeInteger(price) && Number.isSafeInteger(compare) && price > 0 && compare > price;
    const percent = valid ? Math.floor((compare - price) * 100 / compare) : 0;
    off.hidden = percent < 1;
    reference.hidden = percent < 1;
    banner.querySelector('[data-ew-bf-percent]').textContent = percent > 0 ? percent + '%' : '';
  }
  function stop() { if (timer !== null) clearInterval(timer); timer = null; }
  function tick() {
    if (!Number.isFinite(end) || Date.now() >= end) {
      stop(); banner.hidden = true;
      if (fallback) fallback.hidden = false;
      if (badge) badge.textContent = originalBadge;
      return false;
    }
    banner.hidden = false;
    if (fallback) fallback.hidden = true;
    if (badge) badge.textContent = 'BLACK FRIDAY PRICE';
    const left = Math.ceil((end - Date.now()) / 1000);
    const units = {days: Math.floor(left / 86400), hours: Math.floor(left / 3600) % 24, minutes: Math.floor(left / 60) % 60, seconds: left % 60};
    for (const [name, value] of Object.entries(units)) banner.querySelector('[data-ew-bf-' + name + ']').textContent = String(value).padStart(2, '0');
    clock.hidden = false;
    return true;
  }
  function start() { stop(); if (tick() && !document.hidden) timer = setInterval(tick, 1000); }
  root.dataset.ewBfReady = 'true';
  root.addEventListener('variant:change', event => discount(event.detail?.variant));
  function selectedDiscount() { discount(variants.find(v => String(v.id) === root.querySelector('[data-variant]')?.value)); }
  window.addEventListener('popstate', selectedDiscount);
  window.addEventListener('pageshow', () => { selectedDiscount(); start(); });
  document.addEventListener('visibilitychange', start);
  if (variants.length) selectedDiscount();
  start();
})();
